<div *hasRole="item.permission" class="group-title">
    <span class="hint-text">{{ item.title }}</span>
</div>
<div class="group-items">
    <ng-container *ngFor="let item of item.children">
        <ngc-nav-group *ngIf="item.type=='group'" [item]="item"></ngc-nav-group>
        <ngc-nav-collapse *ngIf="item.type=='collapse'" [item]="item"></ngc-nav-collapse>
        <ngc-nav-item *ngIf="item.type=='item'" [item]="item"></ngc-nav-item>
    </ng-container>
</div>
